import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../components/button/Button';
import PlainButton from '../../components/plain-button/PlainButton';
import PrimaryButton from '../../components/primary-button/PrimaryButton';

import messages from './messages';
import './Footer.scss';

var Footer = function Footer(_ref) {
    var onCancel = _ref.onCancel,
        onRemove = _ref.onRemove,
        onSave = _ref.onSave;
    return React.createElement(
        'div',
        { className: 'metadata-instance-editor-footer' },
        React.createElement(
            'div',
            { className: 'metadata-instance-editor-footer-delete' },
            React.createElement(
                PlainButton,
                {
                    'data-resin-target': 'metadata-instanceremove',
                    type: 'button',
                    onClick: onRemove
                },
                React.createElement(FormattedMessage, messages.metadataRemoveTemplate)
            )
        ),
        React.createElement(
            'div',
            { className: 'metadata-instance-editor-footer-save-cancel' },
            React.createElement(
                Button,
                {
                    'data-resin-target': 'metadata-instancecancel',
                    type: 'button',
                    onClick: onCancel
                },
                React.createElement(FormattedMessage, messages.metadataCancel)
            ),
            onSave && React.createElement(
                PrimaryButton,
                {
                    'data-resin-target': 'metadata-instancesave',
                    type: 'button',
                    onClick: onSave
                },
                React.createElement(FormattedMessage, messages.metadataSave)
            )
        )
    );
};

Footer.propTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};
export default Footer;
import PropTypes from 'prop-types';